import { Component, Input, OnInit, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { ConfirmationInput } from '@/shared/components/confirmation/confirmation.model';
import { StrapiPageComponent } from '@/shared/components/strapi-page/components/strapi-page/strapi-page.component';

import { StrapiGenericComponentService, StrapiParserService } from '@/shared/services';
import { AtomicArticleService } from '@/shared/feature/diagnostics-flow/services/atomic-article.service';
import {
  ComponentElementsGenericComponent,
  ComponentElementsGlobalComponent,
} from '@/shared/interfaces/fault-article.interface';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@/shared/components/base/base.component';

@Component({
  selector: 'vm-start-shell',
  templateUrl: './start-shell.component.html',
  styleUrls: ['./start-shell.component.scss'],
  standalone: true,
  imports: [StrapiPageComponent],
})
export class StartShellComponent extends BaseComponent implements OnInit {
  strapiGenericComponentService = inject(StrapiGenericComponentService);
  strapiParserService = inject(StrapiParserService);
  strapiService = inject(AtomicArticleService);
  oauthService = inject(OAuthService);
  route = inject(ActivatedRoute);

  @Input() confirmationInput: ConfirmationInput;
  strapiUID = ['dc_tv-error-codes_start'];

  ngOnInit() {
    const actionCode = this.route.snapshot.paramMap.get('actionCode')?.toLocaleUpperCase() || '';
    const urlActionCode = this.route.snapshot.paramMap.get('urlActionCode')?.toLocaleLowerCase() + '/' || '/';
    this.strapiService.getArticles(this.strapiUID).subscribe((res) => {
      const errorCodeContent = (res[0].elements[0] as ComponentElementsGlobalComponent).genericComponent.filter(
        (generic: ComponentElementsGenericComponent) =>
          generic?.uid
            ?.toLocaleUpperCase()
            ?.split(',')
            .some((c) => c === actionCode)
      );

      if (errorCodeContent) {
        (res[0].elements[0] as ComponentElementsGlobalComponent).genericComponent = errorCodeContent;
        let art = this.strapiParserService.bindData(res[0], { actionCode, urlActionCode });
        art = this.strapiGenericComponentService.formatArticleContent(art);
        this.confirmationInput = art;
      } else {
        this.toUrl('/tv-error-codes');
      }
    });
  }
}
